'use strict';

/**
 * A context creator for time
 *
 * NOTE; If one would want to create their own version of a time context
 * creator, the build/contexts/createTime helper can be used, to utilize type
 * validation in debug mode.
 *
 * Example:
 * var createTime = require('../build/contexts/createTime');
 * function time() {
 *   return createTime({ timestamp: Date.now() });
 * }
 *
 * It is however not useful do do type validation on something that always
 * returns the proper type.
 *
 * @return {Object}   The context time to be attached to an event
 */
function time() {
  return {
    name: 'context_time',
    data: { timestamp: Date.now() }
  };
}

module.exports = time;
